import {useEffect} from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom'

const EstampRequestWrapper = ({
  setRequestStatus,
}: {
  setRequestStatus: (requestStatus: number) => void
}) => {
  const location = useLocation()
  useEffect(() => {
    if (location.pathname === `/estamp_request/pending_requests`) {
      setRequestStatus(2)
    } else if (location.pathname === `/estamp_request/completed_requests`) {
      setRequestStatus(1)
    }
  }, [location.pathname])
  return (
    <div className='card mb-3'>
      <div className='card-body py-0'>
        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {/* Begin: pending_requests link */}
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === `/estamp_request/pending_requests` && 'active')
                }
                to='pending_requests'
              >
                Pending Requests
              </Link>
            </li>
            {/* End: pending_requests link */}
            {/* Begin: completed_requests link */}
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === `/estamp_request/completed_requests` && 'active')
                }
                to='completed_requests'
              >
                Completed Requests
              </Link>
            </li>
            {/* End: completed_requests link */}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default EstampRequestWrapper
